var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonLink } from '@marketing/components/global/CTA/Button/Button';
import Heading from '@marketing/components/global/typography/Heading';
import FlexSection from '@marketing/components/sections/FlexSection';
import { useMediaQuery } from '@mui/material';
import BlogTile from '../Blog/BlogTile';
function RelatedArticles(_a) {
    var content = _a.content, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? 'beige' : _b;
    var relatedArticles = content.relatedArticles;
    var backgroundColorStyle = backgroundColor === 'beige' ? 'bg-surface-beige' : 'bg-surface-white';
    var isMobile = useMediaQuery('(max-width: 768px)');
    var paddingStyle = 'pt-sm-gutter pb-lg-gutter px-2xs-gutter md:px-2xl-gutter md:py-lg-gutter';
    var articles = relatedArticles.slice(0, 3);
    var ButtonComponent = (_jsx(ButtonLink, __assign({ use: "secondary", href: "/learn", size: "large", className: "w-full md:w-auto md:!min-w-[217px]" }, { children: "View Full Blog" })));
    return (_jsxs(FlexSection, __assign({ paddingStyle: paddingStyle, backgroundColorStyle: backgroundColorStyle, gapStyle: "gap-xl-m" }, { children: [_jsxs("div", __assign({ className: "flex flex-col justify-between items-center gap-xl-m" }, { children: [_jsx(Heading, __assign({ size: "md", className: "text-center md:text-left" }, { children: "Related Articles" })), _jsx("div", __assign({ className: "hidden md:block" }, { children: ButtonComponent }))] })), _jsx("div", __assign({ className: "flex flex-col gap-xs-m md:gap-2xs-m" }, { children: articles.map(function (article, index) {
                    // Unpublished articles can still be linked, and appear as null in the response
                    if (article) {
                        return (_jsx(BlogTile, { blogPostData: article, orientation: isMobile ? 'vertical' : 'horizontal' }, index));
                    }
                }) })), _jsx("div", __assign({ className: "md:hidden" }, { children: ButtonComponent }))] })));
}
export default RelatedArticles;
